export default __webpack_public_path__ + "static/media/rebaz.f5c1c6ad.png";